import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from './Unicon';

export const getPasswordChecks = (password = '') => [
    { label: '10+ characters', met: password.length >= 10 },
    { label: 'Lowercase letter', met: /[a-z]/.test(password) },
    { label: 'Uppercase letter', met: /[A-Z]/.test(password) },
    { label: 'Number', met: /[0-9]/.test(password) },
    { label: 'Special character', met: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password) },
];

const PasswordChecklist = ({ password = '', confirmation = '' }) => (
    <View testID="password-checklist" style={styles.container}>
        <Text style={styles.label}>Use a password with</Text>
        <View style={styles.requirements}>
            {getPasswordChecks(password).map(({ label, met }) => (
                <View key={label} style={styles.requirement} accessibilityLabel={`${label}: ${met ? 'met' : 'not met'}`}>
                    <Unicon name={met ? 'checkmark' : 'remove-outline'} size={14} colorVariant={met ? 'secondary' : 'textSecondary'} />
                    <Text style={styles.requirementText(met)}>{label}</Text>
                </View>
            ))}
        </View>
        <View testID="password-match" style={styles.match}>
            <Unicon name={confirmation && password === confirmation ? 'checkmark' : 'remove-outline'} size={14} colorVariant={confirmation && password === confirmation ? 'secondary' : 'textSecondary'} />
            <Text style={styles.matchText(!!confirmation && password !== confirmation)}>
                {!confirmation ? 'Re-enter your password to confirm.' : password === confirmation ? 'Passwords match' : 'Passwords do not match'}
            </Text>
        </View>
    </View>
);

const styles = StyleSheet.create(({ colors, fonts }) => ({
    container: { marginTop: 12, marginBottom: 20, paddingTop: 14, borderTopWidth: 1, borderTopColor: colors.border },
    label: { color: colors.onSurfaceVariant, fontFamily: fonts.heading, fontSize: 12, marginBottom: 8 },
    requirements: { flexDirection: 'row', flexWrap: 'wrap', columnGap: 16, rowGap: 8 },
    requirement: { flexDirection: 'row', alignItems: 'center', gap: 6, minWidth: '43%' },
    requirementText: (met) => ({ color: met ? colors.secondary : colors.onSurfaceVariant, fontFamily: fonts.body, fontSize: 12 }),
    match: { flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 12 },
    matchText: (mismatch) => ({ color: mismatch ? colors.error : colors.onSurfaceVariant, fontFamily: fonts.body, fontSize: 12, flexShrink: 1 }),
}));

export default PasswordChecklist;
